import IncrementalInput from './IncrementalInput';

export default IncrementalInput;
